import Skills from "./skills";
import EmptySkills from "./emptySkills";

export { EmptySkills };
export default Skills;
